import { createSlice } from "@reduxjs/toolkit";

const partOffers = createSlice({
    name: "partOffers",
    initialState: {
        partOffer: null,
        isLoaded: false,
    },
    reducers: {
        getPartOffer(state, _action) {
            return { ...state, isLoaded: false }
        },
        setPartOffer(state, action) {
            const update = action.payload;

            if (typeof update === 'function') {
                state.partOffer = update(state.partOffer);
            }
            else {
                state.partOffer = update;
            };
            state.isLoaded = true;
        }
    },
});

export const {
    getPartOffer,
    setPartOffer
} = partOffers.actions;

export default partOffers.reducer;
